export default function (transform, left, top) {
  if (window.data.move) {
    window.data.move.style.transform = transform;
    window.data.move.style.left = left;
    window.data.move.style.top = top;
  }
}
